module.exports = __webpack_public_path__ + "img/login_banner_xl_user.13659cbd.png";